<script setup>
import { store } from '@/store/appStore.js'
const promotions = store.pharmacyV2.promotions

// Deterministic placeholder gradient per division, since no real product
// imagery was provided or confirmed — this is a visual stand-in only, meant
// to be replaced with real photography (imageUrl on each MY_PROMOTIONS entry).
const GRADIENTS = ['linear-gradient(135deg,#0F3D3E,#17595B)', 'linear-gradient(135deg,#C99A2E,#92583A)', 'linear-gradient(135deg,#5B4E9E,#3A9B5C)']
function gradient(i) { return GRADIENTS[i % GRADIENTS.length] }
</script>

<template>
  <div>
    <div class="card module-header"><h2>{{ promotions.length }} current offers</h2></div>
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:16px;">
      <div v-for="(promo,i) in promotions" :key="promo.id" class="card" style="overflow:hidden;padding:0;">
        <div :style="{ height: '120px', background: gradient(i), display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontFamily:'var(--font-display)', fontSize:'15px', padding:'0 16px', textAlign:'center' }">
          {{ promo.productName }}
        </div>
        <div style="padding:16px 18px;">
          <h3 style="font-size:15px;margin:0 0 6px;">{{ promo.title }}</h3>
          <p class="muted" style="font-size:13px;margin:0 0 10px;">{{ promo.description }}</p>
          <span class="cell-muted" style="font-size:11.5px;">Valid until {{ promo.validUntil }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
